module.exports = __webpack_public_path__ + "img/hr-green-pita-05.9d728fb1.png";